<template>
    <div>
        <h4>Correo</h4>
        <h6><span> Correspondencia sin entregar: {{undeliveredMail}} </span></h6>
    </div>
</template>
<script>
export default {
    data: () => ({
        undeliveredMail: 0
    }),
    methods: {
        async undeliveredMails() {
            const {data} = await repo.get(`mail/undelivered-mail/${this.accessPoint.client_id}/${this.accessPoint.venue_id}`);
            this.undeliveredMail = data;
        }
    },
    beforeMount(){
        this.undeliveredMails();
    }
}
</script>